import { AppState, MutationClass } from '../../../models';

export class AddPlayedAnimationMutation implements MutationClass {

  public static execute(state: AppState, animationId: string): void {
    if (!state.playedAnimations.includes(animationId)) {
      state.playedAnimations.push(animationId);
    }
  }
}
